import { render, staticRenderFns } from "./LowBalanceAlert.vue?vue&type=template&id=9422d14e&scoped=true"
import script from "./LowBalanceAlert.vue?vue&type=script&lang=js"
export * from "./LowBalanceAlert.vue?vue&type=script&lang=js"
import style0 from "./LowBalanceAlert.vue?vue&type=style&index=0&id=9422d14e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9422d14e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9422d14e')) {
      api.createRecord('9422d14e', component.options)
    } else {
      api.reload('9422d14e', component.options)
    }
    module.hot.accept("./LowBalanceAlert.vue?vue&type=template&id=9422d14e&scoped=true", function () {
      api.rerender('9422d14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/LowBalanceAlert.vue"
export default component.exports